var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.874 1.832a.5.5 0 1 0-.748-.664L6.422 5.336a1 1 0 0 0 0 1.328l3.704 4.168a.5.5 0 1 0 .748-.664L7.169 6zm-5 0a.5.5 0 0 0-.748-.664L1.422 5.336a1 1 0 0 0 0 1.328l3.704 4.168a.5.5 0 1 0 .748-.664L2.169 6z",
    clipRule: "evenodd"
  })));
});
const SvgDoubleChevronLeftsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleChevronLeftsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC44NzM3IDEuODMyMTlDMTEuMDU3MiAxLjYyNTggMTEuMDM4NiAxLjMwOTc3IDEwLjgzMjIgMS4xMjYzMUMxMC42MjU4IDAuOTQyODQ3IDEwLjMwOTcgMC45NjE0MzcgMTAuMTI2MyAxLjE2NzgzTDYuNDIxNTYgNS4zMzU2NUM2LjA4NDc4IDUuNzE0NTMgNi4wODQ3OCA2LjI4NTQ5IDYuNDIxNTYgNi42NjQzN0wxMC4xMjYzIDEwLjgzMjJDMTAuMzA5NyAxMS4wMzg2IDEwLjYyNTggMTEuMDU3MiAxMC44MzIyIDEwLjg3MzdDMTEuMDM4NiAxMC42OTAzIDExLjA1NzIgMTAuMzc0MiAxMC44NzM3IDEwLjE2NzhMNy4xNjg5NyA2LjAwMDAxTDEwLjg3MzcgMS44MzIxOVpNNS44NzM3IDEuODMyMTlDNi4wNTcxNiAxLjYyNTggNi4wMzg1NyAxLjMwOTc2IDUuODMyMTggMS4xMjYzQzUuNjI1NzkgMC45NDI4NDIgNS4zMDk3NSAwLjk2MTQzMiA1LjEyNjI5IDEuMTY3ODJMMS40MjE1NiA1LjMzNTY0QzEuMDg0NzggNS43MTQ1MyAxLjA4NDc4IDYuMjg1NDggMS40MjE1NiA2LjY2NDM3TDUuMTI2MjkgMTAuODMyMkM1LjMwOTc1IDExLjAzODYgNS42MjU3OSAxMS4wNTcyIDUuODMyMTggMTAuODczN0M2LjAzODU3IDEwLjY5MDMgNi4wNTcxNiAxMC4zNzQyIDUuODczNyAxMC4xNjc4TDIuMTY4OTcgNi4wMDAwMUw1Ljg3MzcgMS44MzIxOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";